/**
 * Console logging with a component prefix, so a user action can be traced end to end
 * (`[web:upload] session=… source=… part=3 status=403`). Errors always log; info logs only in dev.
 */
export type Scope = 'api' | 'auth' | 'upload' | 'pipeline' | 'kit' | 'team' | 'customers' | 'projects' | 'review' | 'transcript' | 'download' | 'enhance' | 'prefs' | 'mock' | 'app' | 'devices' | 'branding' | 'domains' | 'email' | 'billing' | 'approvals' | 'publish' | 'tasks' | 'feed' | 'presence' | 'integrations' | 'account' | 'ws-x:calendar' | 'ws-x:insights' | 'editor';

const isDev = import.meta.env.DEV && import.meta.env.MODE !== 'test';

export function logError(scope: Scope, message: string, detail?: unknown): void {
  if (detail === undefined) console.error(`[web:${scope}] ${message}`);
  else console.error(`[web:${scope}] ${message}`, detail);
}

export function logWarn(scope: Scope, message: string, detail?: unknown): void {
  if (detail === undefined) console.warn(`[web:${scope}] ${message}`);
  else console.warn(`[web:${scope}] ${message}`, detail);
}

export function logInfo(scope: Scope, message: string): void {
  if (isDev) console.info(`[web:${scope}] ${message}`);
}
